import React from "react";
import { Plane } from "lucide-react";

export function CityDetail({ activeCat, activeCity }) {
  return (
    <div
      className="mt-4 rounded-xl border border-white/10 bg-black/30 p-4"
      data-testid={`top-city-detail-${activeCat.key}`}
    >
      <div className="flex items-baseline justify-between gap-3">
        <div>
          <div className="text-[10px] uppercase tracking-[0.28em]" style={{ color: activeCat.color }}>
            {activeCat.label}
          </div>
          <div className="font-heading text-3xl mt-1" style={{ color: activeCat.color }}>
            {activeCity.city_display}
          </div>
          <div className="text-[11px] uppercase tracking-widest text-[#A89C98] mt-1">
            {activeCity.country} · {activeCity.lat.toFixed(2)}° {activeCity.lat >= 0 ? "N" : "S"} · {Math.abs(activeCity.lng).toFixed(2)}° {activeCity.lng >= 0 ? "E" : "W"}
          </div>
        </div>
      </div>
      <p className="text-sm text-[#E8DFD3] mt-3 leading-relaxed">{activeCity.meaning}</p>
      {Array.isArray(activeCity.activities) && activeCity.activities.length > 0 && (
        <div className="mt-3">
          <div className="text-[9px] uppercase tracking-[0.28em] text-[#E8DFD3]/70 mb-1.5">
            Once you&apos;re there
          </div>
          <ul className="space-y-1.5">
            {activeCity.activities.map((a) => (
              <li key={a} className="flex gap-2 text-[12px] text-white/85 leading-snug">
                <span className="text-[10px] mt-1 shrink-0" style={{ color: activeCat.color }}>◆</span>
                <span>{a}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
      <div className="mt-4 flex flex-wrap items-center gap-3">
        <a
          href="tel:+18444586266"
          data-testid={`book-trip-btn-${activeCat.key}`}
          className="inline-flex items-center gap-2 rounded-none h-10 px-5 uppercase tracking-widest text-[11px] font-bold bg-[#C8A96E] text-[#15111A] hover:bg-[#A98B55] shadow-[0_0_18px_rgba(200,169,110,0.4)] transition-colors"
        >
          <Plane size={14} />
          Book Trip to {activeCity.city_display}
        </a>
        <a
          href="tel:+18444586266"
          className="text-[11px] uppercase tracking-widest text-[#C8A96E] hover:text-white"
          data-testid={`book-trip-phone-${activeCat.key}`}
        >
          Call · (844) 458-6266
        </a>
      </div>
      <div className="text-[9px] uppercase tracking-widest text-[#A89C98] mt-3">
        Blend of {activeCity.source_lines?.join(" + ")}
      </div>
    </div>
  );
}
